module.exports = __webpack_public_path__ + "assets/update.6cd7c27e.svg";